/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsChangeExpectedPaymentSetting204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsChangeExpectedPaymentSetting505Schema = z.any();

export const optionsChangeExpectedPaymentSettingMutationResponseSchema = z.lazy(
  () => optionsChangeExpectedPaymentSetting204Schema
);
